import Education from './Education';
import Polyclinic from './Polyclinic';
import React, { Fragment } from 'react';
import { connect } from 'dva';
import { createStructuredSelector } from 'reselect';
import {
  showEducationSelector,
  showHomestayDocumentsSelector,
} from '../../../selectors/child';

function ChildIndirectHomestayDocuments({
  showEducation,
  showPolyclinic,
}): JSX.Element {
  return (
    <Fragment>
      {showEducation && <Education />}
      {showPolyclinic && <Polyclinic />}
    </Fragment>
  );
}

const mapStateToProps = createStructuredSelector<any, any>({
  showEducation: showEducationSelector,
  showPolyclinic: showHomestayDocumentsSelector,
});

export default connect(mapStateToProps)(ChildIndirectHomestayDocuments);
